import comp from "./UIModal";
export default comp;
